import { Box, Typography } from "@mui/material";

import styles from "./styles";

const LoadingScreen = () => (
  <Box sx={styles.loadingRoot}>
    <Box sx={styles.loadingIconCircle}>
      <Box sx={styles.loadingSpinner} />
    </Box>
    <Typography sx={styles.loadingTitle}>Finding brands…</Typography>
    <Typography sx={styles.loadingSubtitle}>
      Matching against Bento&apos;s database
    </Typography>
    <Box sx={styles.loadingBarTrack}>
      <Box sx={styles.loadingBarFill} />
    </Box>
  </Box>
);

export default LoadingScreen;
